import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import navContext from "../../../Context/navContext";
import { MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { useParams } from "react-router-dom";
import Loader from "../../../Loader/Loader";
import Modal from "../../../Modal/Modal";
import FormMeeting from "./FormMeeting/FormMeeting";
import { findAll } from "../../../../services/Meeting__Service";
import notifyContext from "../../../Context/notifyContext";

const ListMeeting = () => {
  /* Handle Modal */
  const [viewMeetingId, setViewMeetingId] = useState(0);
  const [modifyMeetingId, setModifyMeetingId] = useState(0);
  const [showAdd, setShowAdd] = useState(false);
  /* End Handle Modal */

  const paramsRoutes = useParams();

  const [id, setId] = useState(paramsRoutes.id);
  const [meeting, setMeeting] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const columns = useMemo(
    () => [
      {
        field: "Object",
        headerName: "Objet",
        minWidth: 200,
        flex: 1,
        valueGetter: (params) => {
          return params.row.objet;
        },
      },
      {
        field: "Client",
        headerName: "Client",
        minWidth: 200,
        valueGetter: (params) => {
          return params.row.client.nom;
        },
      },
      {
        field: "Date de Début",
        headerName: "Date de Début",
        minWidth: 110,
        type: "date",
        valueGetter: (params) => {
          return new Date(params.row.dateStart).toLocaleDateString("fr-FR");
        },
      },

      {
        field: "Heure de Début",
        headerName: "Heure de Début",
        minWidth: 110,
        type: "time",
        valueGetter: (params) => {
          return params.row.timeStart;
        },
      },

      {
        field: "Date de Fin",
        headerName: "Date de Fin",
        minWidth: 110,
        type: "date",
        valueGetter: (params) => {
          return new Date(params.row.dateEnd).toLocaleDateString("fr-FR");
        },
      },

      {
        field: "Heure de Fin",
        headerName: "Heure de Fin",
        minWidth: 110,
        type: "time",
        valueGetter: (params) => {
          return params.row.timeEnd;
        },
      },
      {
        field: "Initée par",
        headerName: "Initée par",
        minWidth: 110,
        valueGetter: (params) => {
          return !params.row.createdBy.isGestionnaire
            ? params.row.createdBy.fullname
            : "Client";
        },
      },
      {
        field: "Lien",
        headerName: "Lien",
        minWidth: 110,
        valueGetter: (params) => {
          return params.row.link ? params.row.link : "";
        },
        renderCell: (params) => {
          return (
            params.value && (
              <a href={params.value} target="_blank">
                Cliquer ici
              </a>
            )
          );
        },
      },

      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdOutlineRemoveRedEye />}
            label="Voir"
            onClick={() => setViewMeetingId(params.id)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdEdit />}
            label="Modifier"
            onClick={() => setModifyMeetingId(params.id)}
            showInMenu
            disabled={params.row.createdBy.isGestionnaire}
          />,
        ],
      },
    ],
    []
  );

  useEffect(() => {
    nav({
      links: [
        {
          href: "/main/meeting",
          linkname: "Réunions",
        },
      ],
      children: (
        <button className="btn" onClick={() => setShowAdd(true)}>
          Nouvelle réunion
        </button>
      ),
    });
  }, []);

  const [reload, setReload] = useState(false);

  useEffect(() => {
    if (!showAdd || reload) {
      setIsLoading(true);
      fetchAllMeeting();
    }
  }, [showAdd, reload]);

  const fetchAllMeeting = async () => {
    findAll()
      .then((response) => {
        setMeeting(response.data);
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
        setReload(false);
      });
  };

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  return (
    <Fragment>
      <div className="file__items">
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={meeting}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>
      {isLoading && <Loader loadingMsg="Chargement" />}

      {viewMeetingId !== 0 && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails de la réunion</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewMeetingId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormMeeting meetingId={viewMeetingId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewMeetingId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {modifyMeetingId !== 0 && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Modification de la réunion</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setModifyMeetingId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <FormMeeting
                  meetingId={modifyMeetingId}
                  modify={true}
                  setReload={setReload}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}

      {showAdd && (
        <Modal>
          <div className="modal modal--show">
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">
                  Programmer une nouvelle réunion
                </h2>
                <button
                  className="btn modal__close"
                  onClick={() => setShowAdd(false)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <br />
                <FormMeeting setShowAdd={setShowAdd} />
                <br />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default ListMeeting;
